module.exports = new __parcel__URL__("rovo-icon.a638efdd.svg").toString();